import { useCallback, useState } from 'react'
import withDialog from '../../../hoc/withDialog'
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk'
import Loading from '@ui-components-3/ui/lib/components/Loading'
import DialogHeader from '../../common/DialogHeader'
import AngleRightIcon from '@ui-components-3/icons/lib/regular/AngleRight'

type AddPaymentMethodDialogProps = {
  onDismiss: () => void
  addErrorRole: () => void
  removeErrorRole: () => void
  paymentFormProps: object
}

const AddPaymentMethodDialog = (props: AddPaymentMethodDialogProps) => {
  const { paymentFormProps, addErrorRole, removeErrorRole, onDismiss } = props

  const [isLoading, setIsLoading] = useState(true)

  const hideLoading = useCallback(() => {
    setIsLoading(false)
  }, [setIsLoading])

  return (
    <div className="w-[480px] max-w-full">
      <div className="mb-2 px-4 py-4 md:px-6">
        <DialogHeader title={'Add New Card'} onClose={onDismiss} />
      </div>
      <div className="relative mx-4 flex min-h-[250px] flex-col md:mx-6">
        {!!isLoading && (
          <div className="absolute left-0 top-0 flex w-full items-center justify-center">
            <Loading />
          </div>
        )}
        <PaymentForm
          formId={'card-form'}
          paymentFormLoaded={hideLoading}
          {...paymentFormProps}
          formProps={{
            className: 'flex flex-col flex-1 justify-between bg-white',
          }}
        >
          <CreditCard
            text="Add Card"
            className="w-full"
            render={(Button) => {
              return (
                <div className="w-full border-t border-t-neutral-300 bg-neutral-900 pb-6 pt-4 ">
                  <Button className="btn btn-primary">
                    Next
                    <AngleRightIcon className="h-4 w-4" aria-hidden="true" />
                  </Button>
                </div>
              )
            }}
            errorClassAdded={addErrorRole}
            errorClassRemoved={removeErrorRole}
          />
        </PaymentForm>
      </div>
    </div>
  )
}

export default withDialog(AddPaymentMethodDialog)
